import LineBedIcon from 'LuxKit/Icons/line/LineBedIcon'
import LineLockAltIcon from 'LuxKit/Icons/line/LineLockAltIcon'
import LineStarIcon from 'LuxKit/Icons/line/LineStarIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import TextLink from 'LuxKit/TextLink'
import Group from 'components/utils/Group'
import { useCallback } from 'react'
import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import { LUX_PLUS_OFFER_CAROUSEL_IDS } from '../LuxPlusOfferCarousels'
import LineUtensilsIcon from 'LuxKit/Icons/line/LineUtensilsIcon'

interface Props {
  onLinkClick: () => void
}

function LuxPlusManageAccountModalBenefitsBlob({ onLinkClick }: Props) {
  const experiencesLink = useCallback((chunks: React.ReactNode) => <TextLink
    href={`#${LUX_PLUS_OFFER_CAROUSEL_IDS.localExperiences}`}
    colour="lux-plus"
    weight="regular"
    onClick={onLinkClick}
  >{chunks}
  </TextLink>, [onLinkClick])

  const flashOffersLink = useCallback((chunks: React.ReactNode) => <TextLink
    href={`#${LUX_PLUS_OFFER_CAROUSEL_IDS.flashOffers}`}
    colour="lux-plus"
    weight="regular"
    onClick={onLinkClick}
  >{chunks}
  </TextLink>, [onLinkClick])

  const inclusionsLink = useCallback((chunks: React.ReactNode) => <TextLink
    href={`#${LUX_PLUS_OFFER_CAROUSEL_IDS.hotelInclusions}`}
    colour="lux-plus"
    weight="regular"
    onClick={onLinkClick}
  >{chunks}
  </TextLink>, [onLinkClick])

  const hiddenOffersLink = useCallback((chunks: React.ReactNode) => <TextLink
    href={`#${LUX_PLUS_OFFER_CAROUSEL_IDS.hiddenOffers}`}
    colour="lux-plus"
    weight="regular"
    onClick={onLinkClick}
  >{chunks}
  </TextLink>, [onLinkClick])

  return <Group direction="vertical" gap={8}>
    <BodyTextBlock variant="medium" startIcon={<LineUtensilsIcon colour="lux-plus" />}>
      <FormattedMessage
        id="4MKLlCvODo5i-zmCrHLn"
        defaultMessage="Member only discounts on <link>local experiences.</link>"
        description="LuxPlus+ benefit: member-only discounts on local experiences"
        values={{ link: experiencesLink }}
      />
    </BodyTextBlock>
    <BodyTextBlock variant="medium" startIcon={<LineBedIcon colour="lux-plus" />}>
      <FormattedMessage
        id="A_48JZ27QO5Fk44aMn5B"
        defaultMessage="Save hundreds every year on our best <link>limited-time hotel offers</link>"
        description="LuxPlus+ benefit: savings on limited-time hotel offers"
        values={{ link: flashOffersLink }}
      />
    </BodyTextBlock>
    <BodyTextBlock variant="medium" startIcon={<LineStarIcon colour="lux-plus" />}>
      <FormattedMessage
        id="EIb6LTLtdnvLul_ZtDty"
        defaultMessage="<link>Bonus inclusions</link>: hotel credit, daily breakfast, upgrades & more"
        description="LuxPlus+ benefit: bonus hotel inclusions like credit, breakfast, and upgrades"
        values={{ link: inclusionsLink }}
      />
    </BodyTextBlock>
    <BodyTextBlock variant="medium" startIcon={<LineLockAltIcon colour="lux-plus" />}>
      <FormattedMessage
        id="KvHMu8gJLCKR_w3flz3X"
        defaultMessage="<link>Hidden offers</link> and early access to our bestselling offers just for members"
        description="LuxPlus+ benefit: hidden offers and early access for members"
        values={{ link: hiddenOffersLink }}
      />
    </BodyTextBlock>
  </Group>
}

export default LuxPlusManageAccountModalBenefitsBlob
